<script setup lang="ts">
import { useTimeAgo } from "@vueuse/core"

import type { Property } from "~/classes/entity"
import type { PropertyColor, PropertySize } from "~/classes/generated/interface"

const props = defineProps({
  time: null,
  type: null,
  propertyId: null,
  size: null,
  color: null,
  selected: { type: Boolean }
})
const { viewModePropertySizes, viewModePropertyColors } = useViewMode()
const timeAgo = useTimeAgo(props.time)
</script>

<template>
  <div
    class="time"
    :data-property-id="propertyId"
    :class="{
      [viewModePropertySizes[size].textCss]: true,
      [viewModePropertyColors[color].textCss]: !selected,
    }"
  >
    <span>{{ timeAgo }}</span>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.time
  @apply text-ellipses-inline rounded-[#{$page-properties-br-overlay}]
  @apply rounded-[#{$page-properties-br-overlay}] px-1.5 py-0.5
  // For some reason overflow wrap doesn't work here?
  word-break: break-word
</style>
